import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { company } from '../config/company';
import s from '../styles/legalStyles';

const Disclaimer = () => {
  return (
    <div style={s.page}>
      <SEO
        title="Zastrzeżenie prawne"
        description={`Zastrzeżenie prawne ${company.brand}. Ważne informacje dotyczące korzystania z naszej strony internetowej.`}
      />
      <div style={s.container}>
        <h1 style={s.title}>Zastrzeżenie prawne</h1>
        <p style={s.lastUpdated}>
          Ostatnia aktualizacja: {company.effectiveDate}
        </p>

        <article style={s.article}>
          <h2 style={s.h2}>Informacje ogólne</h2>
          <p>
            Informacje na stronie {company.website} są opracowywane przez {company.brand} ({company.name}, KvK{' '}
            {company.kvk}) z najwyższą starannością. Z prezentowanych informacji nie można jednak wywodzić żadnych praw.
          </p>

          <h2 style={s.h2}>Brak usług pośrednictwa nieruchomości</h2>
          <p>
            {company.brand} jest niezależną platformą informacyjno-pośredniczącą. Nie jesteśmy agentem nieruchomości,
            rzeczoznawcą ani doradcą prawnym. Faktyczna oferta nieruchomości, transakcja i jej obsługa są realizowane
            przez naszego partnera Nelemans lub inną stronę trzecią.
          </p>

          <h2 style={s.h2}>Brak doradztwa finansowego</h2>
          <p>
            Informacje na tej stronie dotyczące inwestowania w hiszpańskie nieruchomości, zwrotu z inwestycji, podatków
            i kredytów hipotecznych mają charakter wyłącznie ogólnoinformacyjny. Nie stanowią one{' '}
            <strong>doradztwa finansowego, podatkowego ani prawnego</strong>. Zawsze konsultuj się z wykwalifikowanym
            doradcą w swojej indywidualnej sytuacji.
          </p>

          <h2 style={s.h2}>Linki zewnętrzne</h2>
          <p>
            Strona zawiera linki do witryn zewnętrznych. {company.brand} nie ponosi odpowiedzialności za treść,
            wiarygodność ani dostępność tych witryn.
          </p>

          <h2 style={s.h2}>Zmiany</h2>
          <p>
            {company.brand} zastrzega sobie prawo do zmiany treści strony oraz niniejszego zastrzeżenia prawnego w
            dowolnym momencie, bez uprzedniego powiadomienia.
          </p>

          <h2 style={s.h2}>Kontakt</h2>
          <p>
            Masz uwagi lub pytania? Napisz na{' '}
            <a style={s.link} href={`mailto:${company.email}`}>{company.email}</a>.
          </p>

          <p style={s.footnote}>
            Zobacz także naszą <Link style={s.link} to="/privacy">politykę prywatności</Link>,{' '}
            <Link style={s.link} to="/cookies">politykę plików cookie</Link> oraz{' '}
            <Link style={s.link} to="/voorwaarden">regulamin</Link>.
          </p>
        </article>
      </div>
    </div>
  );
};

export default Disclaimer;
